<template>
  <BaseContainer style="height:100%" class="one_table">
    <TableMain name="one table" ref="TestTable2" :fields="fields" :title="table_title.title1"
      :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
      :show_date_picker="true" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
      :query_button_label="query_lable" :isBusy="isBusy" :show_toolbar_button="[0, 0, 0, 0, 0]"
      :table_height_adjust="-8" @on_query="on_query" tableref="29219d53ab4e4cbdbcaa80583515c9f5">
      <template #query>
        <el-input :placeholder="$t('common.provider') + $t('common.num')" clearable size="small" style="width: 120px"
          v-model="AccountNum"></el-input>
        <el-input :placeholder="$t('common.provider') + $t('common.name')" class="ml-1" clearable size="small"
          style="width: 180px" v-model="SEI_Name"></el-input>
        <el-input :placeholder="$t('common.invent') + $t('common.num')" class="ml-1" clearable size="small"
          style="width: 120px" v-model="ItemId"></el-input>
        <el-input :placeholder="$t('common.invent') + $t('common.name')" class="ml-1" clearable size="small"
          style="width: 180px" v-model="NameAlias"></el-input>
      </template>
    </TableMain>
  </BaseContainer>
</template>

<script>
import * as saleOrderDispatchVendSearchController from "../../controllers/sd/saleOrderDispatchVendSearchController"
import BaseContainer from "../components/BaseContainer"
import TestQueryPanel from "../components/base/TestQueryPanel"
import TableMain from "../components/table/TableMain"

export default {
  name: "saleOrderDispatchVendSearch",
  components: {
    BaseContainer,
    TableMain,
    TestQueryPanel,
  },
  data() {
    return {
      date_picker_label: this.$t("common.delivery_date_start_end"),
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_dispatch_detail_vend",
      },
      fields: saleOrderDispatchVendSearchController.fields.default,
      AccountNum: "",
      SEI_Name: "",
      ItemId: "",
      NameAlias: "",
      isBusy: false,
    }
  },
  created() { },
  methods: {
    //#region 查询
    async on_query(set_data, date_range) {
      this.isBusy = true
      set_data([])
      let _fromDate = "",
        _toDate = ""
      let _params = {
        is_deleted: { "=": 0 },
        is_approved: { "=": 1 },
        SEI_Name: { like: "%" + this.SEI_Name + "%" },
        NameAlias: { like: "%" + this.NameAlias + "%" },
      }
      if (this.AccountNum != "") {
        _params.AccountNum = { like: "%" + this.AccountNum + "%" }
      }
      if (this.ItemId != "") {
        _params.ItemId = { like: "%" + this.ItemId + "%" }
      }
      if (
        !_.isNull(date_range) &&
        this.AccountNum == "" &&
        this.SEI_Name == "" &&
        this.ItemId == "" &&
        this.NameAlias == ""
      ) {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        _params["delivery_date"] = { ">=": _fromDate, "<=": _toDate }
      }
      let _result = await saleOrderDispatchVendSearchController.methods.getData(
        _params
      )
      if (!_.isNull(_result) && _result && _result.length > 0) {
        set_data(_.orderBy(_result[0], ["id"], ["desc"]))
      }
      this.isBusy = false
    },
    //#endregion
  },
}
</script>
